module.exports = __webpack_public_path__ + "static/media/4.ca0539b2.png";